var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivebatterycertificationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.498,
    height: 49.52,
    viewBox: "0 0 58.498 49.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4380",
    "data-name": "Group 4380",
    transform: "translate(11657.831 -8937.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4377",
    "data-name": "Group 4377",
    transform: "translate(-11657.83 8937.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_236",
    "data-name": "Subtraction 236",
    d: "M31.991,35.995H1.8A1.824,1.824,0,0,1,0,34.152V6.516A1.824,1.824,0,0,1,1.8,4.673H3.116V1.558A1.559,1.559,0,0,1,4.673,0h7.789a1.56,1.56,0,0,1,1.558,1.558V4.673h17.2V1.558A1.559,1.559,0,0,1,32.774,0h7.789A1.56,1.56,0,0,1,42.12,1.558V4.673h2.874a1.824,1.824,0,0,1,1.8,1.843V19.409h-1.8V10.455H1.8v23.7H31.991v1.841ZM1.8,6.516V9.032H44.994V6.516ZM32.774,1.558V4.673h7.789V1.558Zm-28.1,0V4.673h7.789V1.558ZM20.817,29.5h0l1.554-4.621-3.234-.86L24.7,18l-1.883,4.544,3.25.833Zm13.91-9.936H33.509V17.126H31.073V15.908h2.435V13.473h1.218v2.435h2.435v1.218H34.727v2.434ZM15.244,17.126H9.156V15.908h6.089v1.217Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3413",
    "data-name": "Group 3413",
    transform: "translate(32.274 21.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "award",
    d: "M19.014,26.034h-.077a.8.8,0,0,1-.422-.114.771.771,0,0,1-.294-.318l-4.267-7.754c-.153.018-.292.03-.421.037s-.268.013-.422.013c-.172,0-.323,0-.46-.013s-.295-.02-.46-.037L8,25.6a.771.771,0,0,1-.294.318.8.8,0,0,1-.422.114H7.235a.891.891,0,0,1-.447-.165.74.74,0,0,1-.269-.368l-1.4-3.89L1,22.526a.675.675,0,0,1-.211.035.7.7,0,0,1-.249-.048.726.726,0,0,1-.359-.293A.751.751,0,0,1,0,21.8a.677.677,0,0,1,.1-.445l4.8-8.72A8.841,8.841,0,0,1,4.118,8.95a8.715,8.715,0,0,1,.7-3.485A9,9,0,0,1,9.611.7a9.114,9.114,0,0,1,7,0,8.956,8.956,0,0,1,2.849,1.919A9.4,9.4,0,0,1,21.39,5.465,8.612,8.612,0,0,1,22.1,8.95a8.445,8.445,0,0,1-.2,1.869,10.054,10.054,0,0,1-.563,1.741l4.779,8.8a.688.688,0,0,1,.1.445.889.889,0,0,1-.179.445.764.764,0,0,1-.357.267.7.7,0,0,1-.249.048.675.675,0,0,1-.211-.035l-4.115-.916L19.7,25.5a.74.74,0,0,1-.269.368.861.861,0,0,1-.421.165Zm1.354-11.822a9.325,9.325,0,0,1-2.083,2.035,9.1,9.1,0,0,1-2.644,1.3l3.143,5.7,1.021-2.874a.945.945,0,0,1,.4-.432.746.746,0,0,1,.374-.1.847.847,0,0,1,.2.025l3.04.686-3.45-6.33ZM5.647,19.831a.746.746,0,0,1,.374.1.939.939,0,0,1,.4.432l1.021,2.848,3.066-5.7a9.188,9.188,0,0,1-2.593-1.271,8.84,8.84,0,0,1-2.031-1.984l-3.476,6.28,3.04-.686A.847.847,0,0,1,5.647,19.831Zm7.464-18.2a7.036,7.036,0,0,0-2.861.585A7.816,7.816,0,0,0,7.912,3.788,7.294,7.294,0,0,0,6.328,6.114a7.269,7.269,0,0,0,0,5.671,7.294,7.294,0,0,0,1.584,2.326,7.816,7.816,0,0,0,2.339,1.575,7.262,7.262,0,0,0,5.71,0A7.6,7.6,0,0,0,18.3,14.111a7.372,7.372,0,0,0,1.572-2.326,7.288,7.288,0,0,0,0-5.671A7.372,7.372,0,0,0,18.3,3.788a7.6,7.6,0,0,0-2.337-1.575A7.075,7.075,0,0,0,13.111,1.627Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6361",
    "data-name": "Path 6361",
    d: "M28.35-.1h-29.4A.948.948,0,0,1-2-1.052.948.948,0,0,1-1.052-2h29.4a.948.948,0,0,1,.948.948A.948.948,0,0,1,28.35-.1Z",
    transform: "translate(-11655.764 8978.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6362",
    "data-name": "Path 6362",
    d: "M-1.052,7.484A.948.948,0,0,1-2,6.536V-1.052A.948.948,0,0,1-1.052-2,.948.948,0,0,1-.1-1.052V6.536A.948.948,0,0,1-1.052,7.484Z",
    transform: "translate(-11635.602 8979.871)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivebatterycertificationicon);
export default __webpack_public_path__ + "static/media/live battery certification icon.c8ef9c7263ae139e5c6e6545c8147e59.svg";
export { ForwardRef as ReactComponent };